<app-pos-shift-open-form-wrapper
  data-testid="pos-shift-open-view-form-wrapper"
  [config]="config"
  [editMode]="false"
  [viewMode]="true"
></app-pos-shift-open-form-wrapper>
